(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ClusterDeleteController',ClusterDeleteController);

    ClusterDeleteController.$inject = ['$uibModalInstance', 'entity', 'Cluster'];

    function ClusterDeleteController($uibModalInstance, entity, Cluster) {
        var vm = this;
        vm.cluster = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Cluster.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
